// extracted by mini-css-extract-plugin
module.exports = {"linkActive":"_3IDuB","icon":"_3lCzm","bubble":"nbvT8","collection":"_10b30"};